<template>
    <div class="report-page">
        <!-- 0、顶部标题栏部分 -->
        <report-title-bar v-if="!fromEmbedded || (fromEmbedded && !isIphone)"></report-title-bar>

        <!-- 1、介绍内容部分 -->
        <div class="report-main-content-box" v-bind:class="{'no-padding-top':(fromEmbedded && isIphone)}">
            <div class="report-main-content">
                <p>根据人们多年科学研究发现，整个世界是由能量体组成，包括我们每一个人、每一物都是一个能量体。生活在地球上的人类必然受天体干扰、地球磁场支撑等时间及空间综合能量的作用，进而产生了人的旦夕祸福。</p>
                <p class="report-text-yellow">而八字则是对这些能量综合考量，对人生起伏状态的表述工具。</p>
                <p>本测评根据上千年易学智慧大数据提炼而成，以出生时间及地点的地球磁场、时空能量、天体能量为主经人工智能运算得出，供大家学习参考。</p>
            </div>
        </div>

        <!-- 2、结果部分 -->
        <report-result></report-result>

        <!-- 微信扫码支付弹框 -->
        <web-wechat-pay-code></web-wechat-pay-code>

        <!-- 3、底部背景 -->
        <div class="report-bottom-bg"></div>
    </div>
</template>

<script>
import ReportTitleBar from '../../layouts/report/ReportTitleBar.vue'
import ReportResult from '../../layouts/report/ReportResult.vue'
import WebWechatPayCode from '../../layouts/web/WebWechatPayCode.vue'
import { UA } from '../../modules/utils';
export default {
    name: 'ReportPage',
    components: { ReportTitleBar, ReportResult, WebWechatPayCode },
    computed: {
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded;
        }
    },
    data() {
        return {
            isIphone: false
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            window.scrollTo(0, 0);
            me.initData();
            me.isIphone = UA.isIphone();
        }, 20);
    },
    methods: {
        initData() {
            var curPath = this.$router.history.current.path,
                curParams = this.$router.history.current.params,
                detailInfo = this.$store.state.detail.personInfo;
            console.log('initData-----', curParams, detailInfo)
            if(curPath.indexOf('embedded') == -1 && !detailInfo.id) {
                this.$router.replace('/record')
            }
        }
    }
}
</script>